

import VesselMonitoringSingleBay from "./VesselMonitoringSingleBay.vue";

export default {
  components: {
    VesselMonitoringSingleBay
  },
  props: {
    vesselHatch: {
    }
  },
  mounted() {
  }
}
